import { marketingGoalActivityFeedLimit, RegionId, TaskTypeId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import React from "react";
import { filterActivityItemsByType } from "./activity-type-filter";
import { DrillRecords } from "./drill-records";
import { RecentActivityRow } from "./recent-activity-row";

interface MyActivityRecordsProps {
    regionId: RegionId;
    month: string;
    taskTypeId: TaskTypeId;
    onClear: () => void;
}

export const MyActivityRecords: React.FC<MyActivityRecordsProps> = ({
    regionId,
    month,
    taskTypeId,
    onClear,
}) => {
    const trpcClient = trpc.useTRPC();
    const feedQuery = useQuery({
        ...trpcClient.marketingGoal.myActivityFeed.queryOptions({ regionId, month }),
    });
    const feed = feedQuery.data;
    return (
        <DrillRecords
            resetKey={taskTypeId}
            noun="activity"
            nounPlural="activities"
            items={feed ? filterActivityItemsByType(feed, taskTypeId) : undefined}
            isLoading={feedQuery.isLoading}
            isError={feedQuery.isError}
            emptyMessage="No activity of this type recorded this month."
            atCap={(feed?.length ?? 0) >= marketingGoalActivityFeedLimit}
            capNote={null}
            keyOf={item => item.id}
            renderRow={item => <RecentActivityRow item={item} />}
            onClear={onClear}
            testId="goal-recent-activity"
        />
    );
};
